<template>
	<div class="message-employee">
		<label class="uk-form-label header">Compose Message <span class="uk-align-right uk-margin-remove">{{ message.length }}/{{ messageMaxSize }}</span></label>
		<div class="uk-form-controls">
			<textarea class="uk-textarea" v-model="message" maxlength="160"></textarea>
		</div>
		<button class="uk-button uk-button-primary" type="button" @click="submitMessage"><i class="fas fa-comment fa-flip-horizontal"></i> Send</button>
	</div>
</template>

<script>
import Events from "../../events";
export default {
	name: "MessageEmployeeField",
	components: {},
	props: {
		employeeId:{
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			message:"",
			messageMaxSize:160,
		};
	},
	mounted() {
	},
	methods: {
		submitMessage(){
			axios.post("/api/message/employee/" + this.employeeId, {
				message:this.message
			}).then(() => this.updateMessage());
		},
		updateMessage(){
			Events.fireEvent("reload-messages");
            this.message = "";
		}
	},
}
</script>

<style scoped>

</style>
